import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import ProjectData from './../data/projectData.json';
const OurGallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const projects = ProjectData;

  const openGallery = (images) => {
    setGalleryImages(images);
    setCurrentImageIndex(0);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => setIsGalleryOpen(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const handleOverlayClick = (e) => {
    if (e.target.id === 'gallery-overlay') closeGallery();
  };

  return (
    <>
      {/* Swiper Project Slider */}
      <div className="project-slider-wrapper">
        <Swiper
          className="projectSwiper"
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
          modules={[Autoplay]}
        >
          {projects.map((project, index) => (
            <SwiperSlide key={index}>
              <div
                className="project-item-box"
                onClick={() => openGallery(project.gallery)}
              >
                <div className="project-item">
                  <div className="project-image">
                    <div className="project-featured-image">
                      <figure>
                        <img src={project.image} alt={project.title} onContextMenu={(e)=>e.preventDefault()} />
                      </figure>
                    </div>
                    <div className="project-btn">
                      <a
                        href="#!"
                        onClick={(e) => {
                          e.stopPropagation();
                          openGallery(project.gallery);
                        }}
                      >
                        <img src="images/arrow-white.svg" alt="arrow" />
                      </a>
                    </div>
                  </div>
                  <div className="project-content">
                    <h3>{project.title}</h3>
                    <h2>
                      <a href="#!">{project.info}</a>
                    </h2>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Image Gallery Popup */}
      {isGalleryOpen && (
        <div
          id="gallery-overlay"
          onClick={handleOverlayClick}
          style={{
            display: 'flex',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.85)',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div
            id="popupContent"
            style={{ position: 'relative', textAlign: 'center' }}
          >
            <img
              src={galleryImages[currentImageIndex]}
              alt="Gallery"
              onContextMenu={(e)=>e.preventDefault()}
              style={{
                maxWidth: '90vw',
                maxHeight: '80vh',
                borderRadius: '8px',
              }}
            />
            <button onClick={closeGallery} style={closeBtn}>✕</button>
            <button onClick={prevImage} style={{ ...navBtn, left: '-50px' }}>{'<'}</button>
            <button onClick={nextImage} style={{ ...navBtn, right: '-50px' }}>{'>'}</button>
          </div>
        </div>
      )}
    </>
  );
};

// Styles for buttons
const closeBtn = {
  position: 'absolute',
  top: '-40px',
  right: '0',
  fontSize: '24px',
  background: 'transparent',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
};

const navBtn = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '30px',
  background: 'transparent',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
};

export default OurGallery;
